var isNull = function isNull(value) {
  return value === null;
};

export default isNull;